<template>
  <div class="main-container thankyou" role="alert" ref="thankyouContainer">
    <div class="col-12 thankyou-content-holder">
      <div class="thankyou-content-flex">
        <div v-html="thankyou.thankYouHeader" class="thankyou-title"></div>
        <div v-html="thankyou.thankYouText" class="thankyou-content"></div>
      </div>
      <div>
        <button @click="$emit('reset-view')">
          {{ thankyou.backToPoliciesButtonLabel }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThankYou",
  props: {
    thankyou: Object,
  },
  // mounted() {
  //   this.$nextTick(() => {
  //     const thankyouContainer = this.$refs.thankyouContainer;

  //     if (thankyouContainer) {
  //       // ADA - Scroll to the thankyou container
  //       thankyouContainer.scrollIntoView({ behavior: "smooth", block: "start" });
  //     }
  //   });
  // },
};
</script>

<style lang="scss">
.main-container {
  &.thankyou {
    padding: 40px;
    background: var(--backgroundAccent);

    @include media-breakpoint-down(md) {
      padding: 30px;
    }
  }
}

.thankyou-content-flex {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
}

.thankyou-content-holder {
  display: flex;
  flex-direction: column;
  row-gap: 30px;

  button {
    @include round-btn();
    margin-top: 10px;
  }
}

.thankyou-title {
  font-size: 40px;
  line-height: 150%;
  font-weight: 700;
  color: var(--primaryText);
  font-family: var(--micrositeTypeStyle);

  p {
    font-size: inherit;
    line-height: inherit;
    margin: 0;
  }
}

.thankyou-content {
  font-size: 15px;
  line-height: 150%;
  color: var(--primaryText);
  font-family: var(--micrositeTypeStyle);

  p {
    margin: 0;
  }
}
</style>
